import { request } from '../request'
import { Keyword } from '../types'

export class KeywordsService {

  getKeyword(customerId: number, id: number): Promise<Keyword> {
    return request.get(`/api/customers/${customerId}/keywords/${id}.json`)
  }

  getKeywords(customerId: number, ids: number[] = null): Promise<Keyword[]> {
    const query = ids ? { ids } : {}
    return request.get(`/api/customers/${customerId}/keywords.json`, query)
  }

  getKeywordsByState(customerId: number, state: string): Promise<Keyword[]> {
    return request.get(`/api/customers/${customerId}/keywords.json`, { state })
  }

  getKeywordsByScope(customerId: number, scope: string): Promise<Keyword[]> {
    return request.get(`/api/customers/${customerId}/keywords.json`, { scope })
  }

  updateKeyword(customerId: number, keywordId: number, updates: Object): Promise<any> {
    return request.put(`/api/customers/${customerId}/keywords/${keywordId}.json`, { keyword: updates })
  }

  createKeyword(customerId: number, keyword: object): Promise<Keyword> {
    return request.post(`/api/customers/${customerId}/keywords.json`, { keyword })
  }

  deleteKeyword(customerId: number, keywordId: number): Promise<any> {
    return request.del(`/api/customers/${customerId}/keywords/${keywordId}.json`)
  }

  acceptKeyword(customerId: number, keywordId: number): Promise<any> {
    return request.put(`/api/customers/${customerId}/keywords/${keywordId}/accept.json`)
  }

  declineKeyword(customerId: number, keywordId: number): Promise<any> {
    return request.put(`/api/customers/${customerId}/keywords/${keywordId}/decline.json`)
  }

}
